module.exports = __webpack_public_path__ + "img/birth.eed9153b.svg";